import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuditEntryVm, AuditAction, PagedResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class AuditService {
  private http = inject(HttpClient);
  private base(tenantId: string) { return `${environment.apiBaseUrl}/tenants/${tenantId}/audit`; }

  list(tenantId: string, params?: {
    action?: AuditAction;
    actor?: string;
    from?: string;
    to?: string;
    page?: number;
    pageSize?: number;
  }): Observable<PagedResponse<AuditEntryVm>> {
    let hp = new HttpParams();
    if (params?.action) hp = hp.set('action', params.action);
    if (params?.actor) hp = hp.set('actor', params.actor);
    if (params?.from) hp = hp.set('from', params.from);
    if (params?.to) hp = hp.set('to', params.to);
    if (params?.page) hp = hp.set('page', params.page.toString());
    if (params?.pageSize) hp = hp.set('pageSize', params.pageSize.toString());
    return this.http.get<PagedResponse<AuditEntryVm>>(this.base(tenantId), { params: hp });
  }
}
